var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import styled, { css } from 'styled-components';
// Styles
import { getPrefixLabelStylesByVariant } from './getPrefixLabelStylesByVariant';
import { getColorByContentColor } from '../../../common/styles/getColorByContentColor';
import { getTypographyStyles } from '../../../common/styles/typography';
// @todo: This needs a rename - to be done in a major version release
export var PrefixLabel = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  display: inline;\n\n  font-style: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n\n  ", "\n"], ["\n  ", ";\n  display: inline;\n\n  font-style: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, truncateText = _a.truncateText;
    return getTypographyStyles(truncateText, theme);
}, function (_a) {
    var fontStyle = _a.fontStyle;
    return fontStyle || 'normal';
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight || 'normal';
}, function (_a) {
    var styleVariant = _a.styleVariant, theme = _a.theme;
    return getPrefixLabelStylesByVariant(styleVariant, theme);
}, function (_a) {
    var contentColor = _a.contentColor, theme = _a.theme;
    return contentColor && getColorByContentColor(contentColor, theme);
}, function (_a) {
    var overflowWrap = _a.overflowWrap;
    return overflowWrap && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      overflow-wrap: ", ";\n    "], ["\n      overflow-wrap: ", ";\n    "])), overflowWrap);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=PrefixLabel.js.map